<div class="c-modal c-modal--md">
	<div mat-dialog-content class="c-modal__dialog">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p class="c-modal__title c-text c-text--xl">{{ 'Chats.Other.Ai_Bot_Summary' | translate }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<p class="c-text">{{ vm.summary }}</p>
		</div>
		<div class="c-modal__footer">
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right u-no-p">
					<button id="copySummaryButton" type="button" class="c-button c-button--s1 c-button--fit" (click)="vm.copySummary()">{{ 'Common.Copy' | translate}}</button>
				</div>
			</div>
		</div>
	</div>
</div>
